import {
  Delete as IconDelete,
  Language as IconLanguage
} from '@mui/icons-material';
import ActionOnSelectedItems, {
  ActionConfig
} from 'Components/Shared/ActionOnSelectedItems/ActionOnSelectedItems';
import useTranslate from 'Hooks/useTranslate';
import RemoveDomain from './RemoveDomain';

interface Props {
  selectedIds: string[];
  selectAllEnabled: boolean;
  totalCount: number;
  organizationCode: string;
  onReloadDomains: () => void;

  onSelect: (ids: string[] | null) => void;
}

function ActionOnSelectedDomains(props: Readonly<Props>) {
  const ts = useTranslate();
  const {
    totalCount,
    selectedIds,
    selectAllEnabled,
    organizationCode,
    onReloadDomains,
    onSelect
  } = props;

  const actions: ActionConfig[] = [
    {
      key: 'removeDomains',
      icon: <IconDelete />,
      tooltip: ts('common.action.delete'),
      renderMode: 'popper',
      renderPopperContent: (onCollapse: () => void) => (
        <RemoveDomain
          domainNames={selectedIds}
          selectAllEnabled={selectAllEnabled}
          organizationCode={organizationCode}
          selectedDomainCount={selectAllEnabled ? totalCount : selectedIds.length}
          onCollapse={onCollapse}
          onReloadDomains={onReloadDomains}
        />
      )
    }
  ];

  return (
    <ActionOnSelectedItems
      selectedIds={selectedIds}
      selectAllEnabled={selectAllEnabled}
      selectedCount={selectAllEnabled ? totalCount : selectedIds.length}
      totalCount={totalCount}
      onSelect={onSelect}
      icon={<IconLanguage color="primary" />}
      selectionLabel={ts('page.organizationDomains.selectedDomainCount', {
        count: selectAllEnabled ? totalCount : selectedIds.length,
        totalCount: totalCount
      })}
      showMaxSelectedWarning={false}
      showSelectAll={false}
      actions={actions}
    />
  );
}

export default ActionOnSelectedDomains;
